import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingTop: 20,
    paddingHorizontal: 12,
    marginTop: 20,
    marginBottom: 20,
    alignSelf: "center",
    marginHorizontal: 25,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  contentBtn: {
    alignItems: "center",
    alignSelf: "center",
    marginTop: 20,
    marginBottom: 20,
    width: "100%",
  },
  holderTitle: {
    alignSelf: "flex-start",
    fontWeight: "bold",
  },
  btn: {
    padding: 10,
    width: 300,
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    position: "relative",
  },
  textBtn: {
    textTransform: "uppercase",
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },

  lbl: {
    fontWeight: "bold",
  },

  headerCardTxt: {
    alignSelf: "flex-start",
    color: "#077A97",
    fontWeight: "bold",
  },

  hr: {
    alignSelf: "center",
    borderBottomWidth: 1,
    width: "100%",
    marginVertical: 20,
    borderColor: "#077A97",
  },

  goBackBtn: {},
});

export default styles;
